import { mayClearAuthSession } from "utils/publicApi";
import {
  tokenStorage,
  appLocalStorage,
  appSessionStorage,
  registrationSessionStorage,
} from "utils/storage";
import { STORAGE_KEYS } from "constants/index";

export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "="
    );
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

/** JWT exp in ms, or null if missing/invalid. */
export function getTokenExpirationMs(token: string | null): number | null {
  if (!token) return null;
  const payload = decodeJwtPayload(token);
  const exp = payload?.exp;
  if (typeof exp !== "number") return null;
  return exp * 1000;
}

/** True when token is missing or past exp (5s clock-skew buffer). */
export function isAccessTokenExpired(token: string | null): boolean {
  if (!token) return true;
  const expiration = getTokenExpirationMs(token);
  if (!expiration) return false;
  return Date.now() >= expiration - 5000;
}

/** Clear auth tokens/session keys when logout is allowed on this route. */
export function clearAuthSession(): void {
  if (!mayClearAuthSession()) {
    return;
  }
  tokenStorage.clearTokens();
  registrationSessionStorage.clear();
  try {
    appLocalStorage.remove(STORAGE_KEYS.USER);
    appLocalStorage.remove(STORAGE_KEYS.ACCOUNT_TYPE);
  } catch {
    /* ignore */
  }
  try {
    appSessionStorage.clear?.();
  } catch {
    /* ignore */
  }
  try {
    localStorage.setItem("__auth_event__", `logout:${Date.now()}`);
  } catch {
    /* ignore */
  }
}
